import { RunTimeLayoutConfig } from '@umijs/max';

export const layout: RunTimeLayoutConfig = () => {
    return {
        // Return empty config since we're using our own custom layout
    };
};

export function getInitialState() {
    return {
        name: 'NUBA SPA',
    };
}